import { AppAlert, AppBadge, AppCard, AppLoadingSpinner, AppSectionTitle } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { Table, TableBody, TableCell, TableRow } from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import { useSharableOpportunityDetail } from '@opportunities/public/-hooks/useSharableOpportunityDetail'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/opportunities/public/$id/properties/')({
  component: PublicOpportunityDetailPage,
  staticData: {
    breadcrumbLabel: '公開オポチュニティ詳細',
  },
})

function PublicOpportunityDetailPage() {
  const { id } = Route.useParams()
  const opportunityId = Number.parseInt(id, 10)

  const { data, isLoading, error } = useSharableOpportunityDetail({
    id: opportunityId,
  })

  if (isLoading) {
    return (
      <div className='flex items-center justify-center h-full'>
        <AppLoadingSpinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className='p-8'>
        <AppAlert type='error'>データの取得に失敗しました: {error.message}</AppAlert>
      </div>
    )
  }

  if (!data) {
    return (
      <div className='p-8'>
        <AppAlert type='error'>データが見つかりませんでした</AppAlert>
      </div>
    )
  }

  return (
    <div className='h-full overflow-y-auto'>
      <AppSectionTitle>公開オポチュニティ詳細</AppSectionTitle>

      <div className='p-8'>
        <AppCard>
          {/* カードヘッダー */}
          <div className='flex items-center justify-between mb-6'>
            <h3 className='text-xl font-semibold'>公開オポ事例その{data.id}</h3>
            <div className='flex gap-2'>
              {data.shift_service_name && (
                <AppBadge color='orange' className='text-xs'>
                  {data.shift_service_name}
                </AppBadge>
              )}
              {data.shift_service_categories_name && (
                <AppBadge color='green' className='text-xs'>
                  {data.shift_service_categories_name}
                </AppBadge>
              )}
            </div>
          </div>

          {/* 詳細テーブル */}
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className='font-semibold w-48'>顧客課題</TableCell>
                <TableCell>{data.customer_issue || '-'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-semibold'>提案概要</TableCell>
                <TableCell>{data.proposal_summary || '-'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-semibold'>背景</TableCell>
                <TableCell>{data.background || '-'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-semibold'>きっかけ</TableCell>
                <TableCell>{data.trigger || '-'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-semibold'>説明・詳細</TableCell>
                <TableCell>{data.description || '-'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-semibold'>情報元</TableCell>
                <TableCell>{data.information_route || '-'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='font-semibold'>商談化した理由</TableCell>
                <TableCell>{data.reason_for_negotiation || '-'}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </AppCard>
      </div>
    </div>
  )
}
